<style scoped>
.close {
  cursor: pointer;
  color: #dc3545;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 99;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<template>
  <div>
    <b-row v-if="employments.length === 0">
      <b-col>
        <div class="text-center">
          It seems that you haven't added any employment records yet.
        </div>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col>
        <b-row>
          <b-col>
            <h5 class="text-center">Employment Records</h5>
            <hr />
          </b-col>
        </b-row>
        <b-row
          class="mb-3"
          v-for="employment in employments"
          :key="employment.from_date"
        >
          <b-col>
            <b-card>
              <b-row class="mb-3">
                <font-awesome-icon
                  size="sm"
                  @click="confirmRemove(employment)"
                  id="btn-remove-employment"
                  class="close mr-2 mt-2"
                  icon="times"
                />
                <b-col>
                  <div><strong>Self employed: </strong> {{ employment.selfEmployed | bool }}</div>
                  <div v-if="!employment.selfEmployed">
                    <strong>Employer name: </strong> {{ employment.employer }}
                  </div>
                  <div><strong>Business Phone: </strong> {{ employment.phone}}</div>
                </b-col>
                <b-col>
                  <div><strong>From: </strong> {{ employment.fromDate }}</div>
                  <div v-if="!employment.current">
                    <strong>To: </strong> {{ employment.toDate }}
                  </div>
                  <div v-else>*Current Employment</div>
                </b-col>
              </b-row>
              <hr/>
              <address-display :address="employment"/>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="text-right mt-2">
        <verified-submit-button
          target="new-employment-btn"
          text="+ New Employment Record"
          @submit="showModal = true"
        />
        <verified-submit-button class="mt-1"
          v-if="employments.length"
          target="update-employment-next-btn"
          text="Next"
          @submit="moveToNextTab"
        />
      </b-col>
    </b-row>
    <b-modal
      v-if="user.verified"
      v-model="showModal"
      id="addNewEmploymentModal"
      header-class="anchor-modal"
      ref="addNewEmploymentModal"
      hide-footer
      title="New Employment Record"
    >
      <vue-form-generator
        :schema="schema"
        :options="formOptions"
        :model="model"
        ref="employmentForm"
      ></vue-form-generator>
    </b-modal>
  </div>
</template>

<script>
import helper from '@/libs/helper';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlus, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

import VueFormGenerator from 'vue-form-generator';
import AddressDisplay from '@/components/utils/address/AddressDisplay';
import VerifiedSubmitButton from '@/components/utils/buttons/form/VerifiedSubmitButton';

import employmentSchema from '@/components/profile/sections/tabs/employment/resources/schema';

import { DEFINE_PROFILE_EMPLOYMENT } from '@/vuex/modules/profile/types/actions';
import { FINANCIAL_TAB } from '@/components/profile/sections/tabs/tabNumbers';

library.add([faPlus, faTimes, faSave]);

export default {
  components: {
    'vue-form-generator': VueFormGenerator.component,
    AddressDisplay,
    VerifiedSubmitButton,
  },
  data() {
    return {
      showModal: false,
      model: {},
      schema: employmentSchema.schema(this.saveNewEmployment),
      formOptions: employmentSchema.formOptions,
      FINANCIAL_TAB,
    };
  },
  computed: {
    employments() {
      const profile = this.$store.getters.profile;
      if (profile && profile.employment) {
        const employments = helper.copy(profile.employment);
        employments.forEach((employment) => {
          /* eslint no-param-reassign: ["error", { "props": false }] */
          employment.phone = helper.phoneMask(employment.phone);
        });
        return employments;
      }
      return [];
    },
    user() {
      return this.$store.getters.user;
    },
    loanAppDoc() {
      return this.$store.getters.documents.find(doc => doc.type === 'Loan App') || { approvedCount: 0 };
    },
  },
  methods: {
    isValid() {
      return this.employments.length > 0;
    },
    clearValidationErrors() {},
    confirmRemove(employment) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this action!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
      }).then((result) => {
        if (result.value) {
          this.removeEmployment(employment);
        }
      });
    },
    removeEmployment(employment) {
      this.$reqs.delete(`/users/${this.user.id}/profile/employment/${employment.id}`)
        .then((response) => {
          this.$store.dispatch(DEFINE_PROFILE_EMPLOYMENT, { employment: response.data.employment });
          this.$emit('tab-info-updated', 'Employment');
        })
        .catch(() => {});
    },
    saveNewEmployment(model) {
      const data = helper.copy(model);
      const addressData = helper.copy(data.address);
      delete data.address;
      Object.keys(addressData).forEach((key) => {
        data[key] = addressData[key];
      });
      this.$reqs.post(`/users/${this.user.id}/profile/employment`, data)
        .then((response) => {
          this.$store.dispatch(DEFINE_PROFILE_EMPLOYMENT, { employment: response.data.employment });
          this.$emit('tab-info-updated', 'Employment');
          this.model = {};
          this.showModal = false;
        })
        .catch(() => {});
    },
    moveToNextTab() {
      this.$emit('move-to-next-tab', FINANCIAL_TAB);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/tabs/employment/EmploymentContent.vue